/**
 * @file  Logo/index.ts
 * @description  application logo with styles
 *
 * @author ogarcia (ozkary)
 *
 */
import React from 'react';
import * as S from './styles';

/**
 * image styled element. Resolves to the content folder for all images
 * @param props
 * @description src='image-name.png'
 */
const Image = ({
  src,
  width,
  height,
  className,
  title
}: S.Props): JSX.Element => {
  if (src && src !== '') {
    return (
      <S.Image
        src={`/${src}`}
        title={title}
        alt={title}
        className={className}
        width={width}
        height={height}
      />);
  } else {
    return (<></>);
  }
};

export default Image;
